import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Modulify AI Logo Maker',
    description:
        'Describe your brand and get a logo you can actually ship. Vector files, print-ready, in minutes.',
    url: 'https://logomaker.modulify.ai',
    ogImage: '/logomaker-og.jpg'
}

export const supportEmail = 'logomaker@modulify.ai'

/** The one price. Advertised and charged in exactly one place: this constant. */
export const singleLogoPrice = 7

/** Unlimited plan prices, matching the Stripe prices the checkout uses. */
export const unlimitedMonthlyPrice = 19
export const unlimitedYearlyPrice = 99

export const primaryNav = [
    { label: 'Create', href: '/' },
    { label: 'Community', href: '/community' },
    { label: 'Image to Vector', href: '/image-to-vector' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Blog', href: '/blog' }
] as const

export const footerNav = [
    {
        title: 'Create',
        links: [
            { label: 'Make a logo', href: '/' },
            { label: 'Pricing', href: '/pricing' },
            { label: 'Image to Vector', href: '/image-to-vector' },
            { label: 'Community gallery', href: '/community' }
        ]
    },
    {
        title: 'Account',
        links: [
            { label: 'My logos', href: '/mylogo' },
            { label: 'My conversions', href: '/my-image-to-vector' },
            { label: 'Account settings', href: '/account' },
            { label: 'Sign in', href: '/login' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'Blog', href: '/blog' },
            { label: 'Privacy policy', href: '/privacy' },
            { label: 'Terms', href: '/terms' },
            { label: 'Modulify', href: 'https://modulify.ai', external: true }
        ]
    }
] as const

export const socialLinks = [
    { label: 'X', href: 'https://x.com/modulify' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/modulify-ai' },
    { label: 'Instagram', href: 'https://www.instagram.com/modulify_ai' },
    { label: 'YouTube', href: 'https://www.youtube.com/@ModulifyAI' },
    { label: 'Facebook', href: 'https://www.facebook.com/modulifyai' }
] as const
